import type { StageConfig } from '@capture/shared';

export function RawAdvancedPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const json = JSON.stringify(config.config, null, 2);
  return (
    <div className="stage-panel">
      <label>
        Raw JSON config
        <textarea
          rows={10}
          value={json}
          onChange={(e) => {
            try {
              const parsed: Record<string, unknown> = JSON.parse(e.target.value);
              onChange({ ...config, config: parsed });
            } catch {
              // ignore invalid JSON while typing
            }
          }}
        />
      </label>
    </div>
  );
}
